import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { BsArrowDown, BsCaretDownFill, BsChevronDown } from "react-icons/bs";

export const DilDropdown = ({
  options,
  selectedOption,
  setSelectedOption,
  placeHolder = { value: "", display: "Please select a value" },
  closeOnSelection = true,
  optionBorders = false,
  customIcon, //wrapped in function that returns the component you want to display, i.e. ()=>{return <CustomIcon/>} or (props)=><CustomIcon {...props}/> if you want to inherit the props this component uses for the icon
  styleMergeDropdownContainer,
  styleMergeDropdown,
  styleMergeOptionContainer,
  styleMergeDropdownOption,
}) => {
  // const [selectedItem, setSelectedItem] = useState("Invoice");
  const dropdownContainerRef = useRef();
  // const dropdownRef = useRef();
  // const dropdownItemsRef = useRef([]);
  // dropdownItemsRef.current = []; // reset array every re-render as the dropdown options push themselves into the array every rerender - Update: instead of keeping refs to all the options to see if it was one of them that was clicked on for our handleClickOutsideOfDropdown function, we just check if the container.contains(e.target)
  // console.log(dropdownItemsRef);

  const [showOptions, setShowOptions] = useState(false);
  const handleClickDropdown = useCallback(() => {
    setShowOptions((showOptions) => !showOptions);
  }, [setShowOptions]);

  const handleClickOutOfDropdown = useCallback(
    function handleClickOutOfDropdown(e) {
      // console.log("target: ", e.target);
      if (
        dropdownContainerRef.current &&
        !dropdownContainerRef.current.contains(e.target)
      ) {
        // console.log("clicked outside");
        setShowOptions(false);
      }
      // console.log("clicked inside");
    },
    []
  );
  const escapeDropdown = useCallback(
    function escapeDropdown(e) {
      // console.log(e.key);
      if (e.key === "Escape") {
        setShowOptions(false);
      }
    },
    [setShowOptions]
  );

  useEffect(() => {
    // console.log("rerun event setup");
    //"mousedown" fixed the issues "click" was having (click works more like mouseup)
    document.addEventListener("mousedown", handleClickOutOfDropdown);
    document.addEventListener("keydown", escapeDropdown);
    return () => {
      document.removeEventListener("mousedown", handleClickOutOfDropdown);
      document.removeEventListener("keydown", escapeDropdown);
    };
  }, [handleClickOutOfDropdown, escapeDropdown]);

  const selectedOptionDisplay = useMemo(() => {
    // console.log("recalculated");
    const foundOption = options.find((option) => {
      return option.value === selectedOption;
    });
    // console.log(foundOption);
    if (foundOption) {
      return foundOption.display;
    } else {
      return placeHolder.display;
    }
  }, [options, selectedOption, placeHolder.display]);

  const CustomIcon = customIcon;
  return (
    <div
      ref={dropdownContainerRef}
      style={{
        position: "relative",
        backgroundColor: "rgb(230,230,230)",
        ...styleMergeDropdownContainer,
      }}
    >
      <div
        style={{
          // backgroundColor: "rgb(230,230,230)",
          color: "rgb(144,144,144)",
          fontWeight: "600",
          padding: "10px",
          userSelect: "none",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          ...styleMergeDropdown,
        }}
        onClick={handleClickDropdown}
      >
        <div
          style={{
            flex: 1,
          }}
          className="text-ellipsis"
        >
          {selectedOptionDisplay}
        </div>
        <div>
          {customIcon ? (
            <CustomIcon
              className={
                "dil-dropdown-arrow" + (showOptions ? " dil-show" : " dil-hide")
              }
            />
          ) : (
            <BsCaretDownFill
              size={14}
              className={
                "dil-dropdown-arrow" + (showOptions ? " dil-show" : " dil-hide")
              }
            />
          )}
        </div>
      </div>

      {showOptions && (
        <div
          style={{
            position: "absolute",
            zIndex: 30000,
            boxShadow: "0px 0px 5px 0px rgba(0,0,0,.25)",
            backgroundColor: "white",
            minWidth: "100%",
            ...styleMergeOptionContainer,
          }}
        >
          {options.map((option, index) => {
            return (
              <div
                key={option + index}
                onClick={(e) => {
                  closeOnSelection && setShowOptions(false);
                  setSelectedOption(option.value);
                }}
                style={{
                  padding: "5px",
                  ...styleMergeDropdownOption,
                }}
                className={
                  "dil-dropdown-option" +
                  (optionBorders ? " list-border-bottom" : "")
                }
              >
                {option.display}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
